import * as React from 'react';
import { fetchLayoutsOffers } from '../services';
import { NewbuildingLayoutsContext } from '../shared/context';
export const useLayoutModal = _ref => {
  let {
    newbuildingId,
    houseId,
    layouts,
    isLayoutModalDisabled
  } = _ref;
  const {
    httpApi,
    logger
  } = React.useContext(NewbuildingLayoutsContext);
  const [layoutId, setLayoutId] = React.useState();
  const [isOpened, setIsOpened] = React.useState(false);
  const [loading, setIsLoading] = React.useState(false);
  const [layoutOffers, setLayoutOffers] = React.useState(null);
  const layoutImageUrl = React.useMemo(() => {
    var _layouts$find;
    return (_layouts$find = layouts.find(layout => layout.layoutKey === layoutId)) === null || _layouts$find === void 0 ? void 0 : _layouts$find.image;
  }, [layoutId, layouts]);
  const onLayoutCardClick = layoutKey => {
    if (isLayoutModalDisabled) {
      return;
    }
    setIsLoading(true);
    setIsOpened(true);
    setLayoutOffers(null);
    setLayoutId(layoutKey);
    fetchLayoutsOffers({
      httpApi,
      logger,
      params: {
        newbuildingId,
        houseId,
        layoutKey
      }
    }).then(response => {
      setLayoutOffers(response);
    }).finally(() => {
      setIsLoading(false);
    });
  };
  const onClose = () => setIsOpened(false);
  const onReset = () => {
    setIsLoading(true);
    fetchLayoutsOffers({
      httpApi,
      logger,
      params: {
        newbuildingId,
        houseId,
        layoutKey: layoutId
      }
    }).then(response => {
      setLayoutOffers(response);
    }).finally(() => {
      setIsLoading(false);
    });
  };
  return {
    isOpened,
    loading,
    onLayoutCardClick,
    onClose,
    onReset,
    layoutImageUrl,
    layoutOffers
  };
};